export default "__VITE_ASSET__BS212O6c__"